export const SUPPORTED_LOCALES = ['pt-BR', 'en'] as const;

export type AppLocale = (typeof SUPPORTED_LOCALES)[number];

export const DEFAULT_LOCALE: AppLocale = 'pt-BR';

export const LOCALE_STORAGE_KEY = 'infogov.locale';

export interface LocaleOption {
  code: AppLocale;
  labelKey: string;
}

export const LOCALE_OPTIONS: LocaleOption[] = [
  { code: 'pt-BR', labelKey: 'languages.pt-BR' },
  { code: 'en', labelKey: 'languages.en' },
];

export const LOCALE_ROUTE_SEGMENTS: Record<AppLocale, string> = {
  'pt-BR': 'pt-br',
  en: 'en',
};

export function isAppLocale(value: string): value is AppLocale {
  return SUPPORTED_LOCALES.includes(value as AppLocale);
}

export function resolveInitialLocale(): AppLocale {
  if (typeof window !== 'undefined') {
    const firstSegment = window.location.pathname.split('/').filter(Boolean)[0]?.toLowerCase();
    const localeFromPath = Object.entries(LOCALE_ROUTE_SEGMENTS).find(
      ([, routeSegment]) => routeSegment === firstSegment,
    )?.[0] as AppLocale | undefined;

    return localeFromPath ?? DEFAULT_LOCALE;
  }

  if (typeof localStorage === 'undefined') {
    return DEFAULT_LOCALE;
  }

  const stored = localStorage.getItem(LOCALE_STORAGE_KEY);
  if (stored && isAppLocale(stored)) {
    return stored;
  }

  if (typeof navigator !== 'undefined') {
    const browserLang = navigator.language;
    if (browserLang.startsWith('pt')) {
      return 'pt-BR';
    }
    if (browserLang.startsWith('en')) {
      return 'en';
    }
  }

  return DEFAULT_LOCALE;
}
